<style lang="scss">
.full-media-modal {
  .call-event-image {
    max-width: 100%;
    max-height: 90vh;
  }

  .center-image {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>

<template>
  <div class="container-fluid full-media-modal p-0">
    <div class="row">
      <img class="call-event-image center-image" :src="imageUrl">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'full-screen-image-modal',
    props: {
      imageUrl: {
        type: String,
        required: true,
      },
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>
